import { render, staticRenderFns } from "./DeliveryMethod.vue?vue&type=template&id=432bcc26&scoped=true&"
import script from "./DeliveryMethod.vue?vue&type=script&lang=js&"
export * from "./DeliveryMethod.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryMethod.vue?vue&type=style&index=0&id=432bcc26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432bcc26",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QIcon});qInstall(component, 'directives', {ClosePopup});
